/**
 * This file contains the same enums as DataModels.ts, but declared as objects
 * These objects should only be used by consumers who cannot use const enums for whatever reason
 * Typically, users may encounter issues if they use ts-jest and isolatedModules.
 * Avoiding these EnumObjects saves 1.5KB in package size
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export var EnumObjects;
(function (EnumObjects) {
    EnumObjects.DataClassification = {
        EssentialServiceMetadata: (1 << 0),
        AccountData: (1 << 1),
        SystemMetadata: (1 << 2),
        OrganizationIdentifiableInformation: (1 << 3),
        EndUserIdentifiableInformation: (1 << 4),
        CustomerContent: (1 << 5),
        AccessControl: (1 << 6),
        PublicNonPersonalData: (1 << 7),
        EndUserPseudonymousInformation: (1 << 8),
        PublicPersonalData: (1 << 9),
        SupportData: (1 << 10),
        DirectMeasurementData: (1 << 11),
        Everything: 0xffff
    };
    EnumObjects.DataFieldType = {
        // eslint-disable-next-line id-denylist
        String: 0,
        // eslint-disable-next-line id-denylist
        Boolean: 1,
        Int64: 2,
        Double: 3,
        Guid: 4
    };
    EnumObjects.SamplingPolicy = {
        NotSet: 0,
        Measure: 1,
        Diagnostics: 2,
        CriticalBusinessImpact: 191,
        CriticalCensus: 192,
        CriticalExperimentation: 193,
        CriticalUsage: 194
    };
    EnumObjects.PersistencePriority = {
        NotSet: 0,
        Normal: 1,
        High: 2
    };
    EnumObjects.CostPriority = {
        NotSet: 0,
        Normal: 1,
        High: 2
    };
    EnumObjects.DataCategories = {
        NotSet: 0x00,
        SoftwareSetup: 0x01,
        ProductServiceUsage: 0x02,
        ProductServicePerformance: 0x04,
        DeviceConfiguration: 0x08,
        InkingTypingSpeech: 0x10
    };
    EnumObjects.DiagnosticLevel = {
        ReservedDoNotUse: 0,
        Required: 10,
        BasicEvent: 10,
        Optional: 100,
        FullEvent: 100,
        RequiredServiceData: 110,
        NecessaryServiceDataEvent: 110,
        RequiredServiceDataForEssentialServices: 120,
        AlwaysOnNecessaryServiceDataEvent: 120
    };
    EnumObjects.DnmInterval = {
        Hourly: 1,
        Daily: 2
    };
    EnumObjects.AllowedPartA = {
        ReleaseAudienceGroup: 1,
        WacRing: 2,
        AppName: 3,
        AppPlatform: 4,
        AppVersion: 5
    };
    EnumObjects.CustomerContentType = {
        None: 0x0,
        MocaAddIn: 0x1
    };
    EnumObjects.LogLevel = {
        Error: 0,
        Warning: 1,
        Info: 2,
        Verbose: 3
    };
    EnumObjects.Category = {
        Core: 0,
        Sink: 1,
        Transport: 2
    };
    EnumObjects.PrimaryIdentitySpace = {
        UserObjectId: 'UserObjectId',
        MSACID: 'MSACID',
        /**
         * @deprecated - Use OrgIdPUID instead
         */
        OrgIdPuid: 'OrgIdPuid',
        OrgIdPUID: 'OrgIdPUID',
        OrgIdCID: 'OrgIdCID',
        /**
         * @deprecated - Use MSAPUID instead
         */
        MsaPuid: 'MsaPuid',
        MSAPUID: 'MSAPUID',
        WopiAuth: 'WopiAuth',
        ThirdParty: 'ThirdParty'
    };
    EnumObjects.AudienceGroup = {
        Automation: 'Automation',
        Dogfood: 'Dogfood',
        Microsoft: 'Microsoft',
        Insiders: 'Insiders',
        Production: 'Production'
    };
})(EnumObjects || (EnumObjects = {}));
//# sourceMappingURL=EnumObjects.js.map